import { debounce } from 'lodash';
import { currentBreakpoint } from '../lib/responsive';

export default class AppNotification {

  constructor(el) {

    this.el = el;
    this.wrapper = this.el.parentNode;
    this.contentEl = document.getElementById('main-content');
    this.isPageCart = document.querySelector('.page-cart');
    this.dismissEl = this.el.querySelector('.app-notification-dismiss');
    if (this.dismissEl) {

      this.label = this.dismissEl.getAttribute('data-label');
      this.cookieTtl = this.dismissEl.getAttribute('data-ttl') || 0;
      this.dismissEl.addEventListener('click', this.dismiss.bind(this));
    }
    this.cta = this.el.querySelector('a.is-cta');
    if (this.cta) {

      this.cta.addEventListener('click', this.onCtaClick.bind(this));
    }
    // this.resizeHandler = this.setMargin.bind(this);
    if (this.isPageCart) return;
    window.addEventListener('resize', debounce(this.setMargin.bind(this), 100));
    this.setMargin();
  }

  dismiss(e) {

    // this.el.classList.add('app-notification-dismissed');
    this.hide(true);
    e.preventDefault();
  }

  onCtaClick(e) {

    this.hide(true);
  }

  hide(setCookie) {

    if (setCookie) {

      let cookie = 'NotificationStatus_' + this.label + '=dismissed; path=/; sameSite=Lax';
      if (this.cookieTtl > 0) {
        cookie += '; max-age=' + this.cookieTtl;
      }
      document.cookie = cookie;
    }
    this.el.remove();
    if (this.wrapper.querySelectorAll('.app-notification').length == 0) {

      document.querySelector('.app-notifications').remove();
      document.body.classList.remove('has-notification');
    }
    this.setMargin();
  }

  setMargin() {

    if (currentBreakpoint === 'xs' || currentBreakpoint === 's') {

      this.contentEl.style.marginTop = this.wrapper.getBoundingClientRect().height + 'px';
    } else {

      this.contentEl.style.marginTop = '';
    }
  }

}
